import { TaskOutput } from 'task/model/task.output';
import { Task } from 'task/task';

export abstract class TaskConverterPort {
	public abstract taskAsEntity(output: TaskOutput): Task;

	public abstract tasksAsEntities(outputs: TaskOutput[]): Task[];
}
